import { createLogger } from "vuex";

const debug = process.env.NODE_ENV !== "production";

export const plugins = debug ? [createLogger({})] : [];
